import { useState, useEffect, useCallback } from "react";
import constate from "constate";
import { getAuthenticatedUser, AuthenticatedUser } from "../../api/services";
import { useConfigContext } from ".";

export const useAuthenticatedUser = () => {
  const [user, setUser] = useState<AuthenticatedUser | undefined>(undefined);
  const [loading, setLoading] = useState(true);
  const { authConfig } = useConfigContext();

  const clearUser = useCallback(() => {
    setUser(undefined);
  }, []);

  useEffect(() => {
    (async () => {
      if (loading && authConfig) {
        try {
          setUser(await getAuthenticatedUser());
        } catch (ignored) {}
        setLoading(false);
      }
    })();
  }, [authConfig, loading]);

  return {
    user,
    loading,
    setUser,
    clearUser,
  };
};

export const [
  AuthenticatedUserProvider,
  useAuthenticatedUserContext,
] = constate(useAuthenticatedUser);
